import React from 'react';
export function FitFilterSection() {
  return <section id="fit" className="py-24 md:py-32 pb-16 md:pb-20 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-75">
      <div className="mb-12 sticky top-20 md:static bg-white pb-6 md:pb-0 -mx-6 px-6 md:mx-0 md:px-0 z-10" data-id="element-76">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-77">
          Fit Filter
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black" data-id="element-78">
          Who this is (and isn't) for
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24" data-id="element-79">
        <div data-id="element-80">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-81">
            This fits if:
          </h4>
          <ul className="space-y-6" data-id="element-82">
            <li className="flex items-start" data-id="element-83">
              <span className="mr-4 text-black font-medium" data-id="element-84">—</span>
              <span className="text-lg text-gray-600" data-id="element-85">
                You're pre-PMF or at a moment where the next milestone carries
                outsized consequences
              </span>
            </li>
            <li className="flex items-start" data-id="element-86">
              <span className="mr-4 text-black font-medium" data-id="element-87">—</span>
              <span className="text-lg text-gray-600" data-id="element-88">
                Runway feels tight and expectations are rising
              </span>
            </li>
            <li className="flex items-start" data-id="element-89">
              <span className="mr-4 text-black font-medium" data-id="element-90">—</span>
              <span className="text-lg text-gray-600" data-id="element-91">
                You are the system — decisions and follow-through flow through
                you, and time is scarce
              </span>
            </li>
            <li className="flex items-start" data-id="element-92">
              <span className="mr-4 text-black font-medium" data-id="element-93">—</span>
              <span className="text-lg text-gray-600" data-id="element-94">
                You've raised ahead of your operating maturity
              </span>
            </li>
            <li className="flex items-start" data-id="element-95">
              <span className="mr-4 text-black font-medium" data-id="element-96">—</span>
              <span className="text-lg text-gray-600" data-id="element-97">
                You need momentum without taking on a long-term hire
              </span>
            </li>
          </ul>
        </div>

        <div data-id="element-98">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-99">
            This won't fit if:
          </h4>
          <ul className="space-y-6" data-id="element-100">
            <li className="flex items-start" data-id="element-101">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-102">—</span>
              <span className="text-lg text-gray-400" data-id="element-103">
                You're looking for junior help or simple task delegation
              </span>
            </li>
            <li className="flex items-start" data-id="element-104">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-105">—</span>
              <span className="text-lg text-gray-400" data-id="element-106">
                You want validation more than forward progress
              </span>
            </li>
            <li className="flex items-start" data-id="element-107">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-108">—</span>
              <span className="text-lg text-gray-400" data-id="element-109">
                You're optimizing for a future org instead of stabilizing what
                exists today
              </span>
            </li>
            <li className="flex items-start" data-id="element-110">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-111">—</span>
              <span className="text-lg text-gray-400" data-id="element-112">
                You're not open to focused, time-bound changes
              </span>
            </li>
            <li className="flex items-start" data-id="element-113">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-114">—</span>
              <span className="text-lg text-gray-400" data-id="element-115">
                You want someone to avoid hard conversations
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}